"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toEditorFormat = exports.fromEditorFormat = void 0;

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _constants = require("@insided/deprecated-libs/constants");

var toEditorFormat = function toEditorFormat(content) {
  if (!content) return content;
  content = content.replace(/\s<user-mention/gm, '&nbsp;<user-mention');
  var el = document.createElement('div');
  el.innerHTML = content;
  var BBCodeCodeBlocks = el.querySelectorAll('.threadCode');
  BBCodeCodeBlocks.forEach(function (BBCodeCodeBlock) {
    var oldCode = BBCodeCodeBlock.getElementsByTagName('pre')[0];
    var newCode = document.createElement('code');
    newCode.innerHTML = oldCode.innerHTML;
    oldCode.innerHTML = newCode.outerHTML;
    BBCodeCodeBlock.replaceWith(newCode);
  });
  var codeBlocks = el.querySelectorAll('code');
  codeBlocks.forEach(function (codeBlock) {
    codeBlock.innerHTML = codeBlock.innerHTML.replace(/(<br>)/gm, '\n');
  });
  var spoilerContainersConverted = el.querySelectorAll('content-spoiler');

  if (spoilerContainersConverted.length) {
    spoilerContainersConverted.forEach(function (spoilerContainerConverted) {
      var spoilerContainer = document.createElement('div');
      spoilerContainer.classList.add('spoiler-container');
      spoilerContainer.innerHTML = "<div class='hideBtn'>Hide content</div><div class='content-spoiler'>".concat(spoilerContainerConverted.innerHTML, "</div>");
      spoilerContainerConverted.replaceWith(spoilerContainer);
    });
  }

  var quotes = el.querySelectorAll('content-quote');
  quotes.forEach(function (quote) {
    var quotedUser = document.createElement('div');
    quotedUser.className = 'content-quote-username';
    quotedUser.textContent = "".concat(quote.getAttribute('data-username'), " ").concat((0, _translations.t)('Common', 'wrote'), ":");
    var quotedContent = document.createElement('div');
    quotedContent.className = 'content-quote-content';

    while (quote.childNodes.length > 0) {
      quotedContent.appendChild(quote.childNodes[0]);
    }

    quote.appendChild(quotedUser);
    quote.appendChild(quotedContent);
  });
  el.querySelectorAll('figcaption').forEach(function (caption) {
    if (!caption.parentElement || caption.parentElement.tagName.toLowerCase() === 'figure') return;
    var paragraph = document.createElement('p');
    paragraph.innerHTML = caption.innerHTML;
    caption.replaceWith(paragraph);
  });
  var emojies = el.querySelectorAll("img[src^=\"".concat(_constants.ckeditorEmojiUrl, "\"]"));
  emojies.forEach(function (emoji) {
    var unicode = emoji.getAttribute('alt');
    emoji.replaceWith(unicode !== null && unicode !== void 0 ? unicode : '');
  });
  return el.innerHTML;
};

exports.toEditorFormat = toEditorFormat;

var fromEditorFormat = function fromEditorFormat(content) {
  if (!content) return content;
  var el = document.createElement('div');
  el.innerHTML = content;
  var embeds = el.querySelectorAll('[data-oembed-url]');
  embeds.forEach(function (embed) {
    var _embed$getAttribute;

    var embedNode = document.createElement('oembed');
    embedNode.setAttribute('url', (_embed$getAttribute = embed.getAttribute('data-oembed-url')) !== null && _embed$getAttribute !== void 0 ? _embed$getAttribute : '');
    embed.replaceWith(embedNode);
  });
  var codeBlocks = el.querySelectorAll('code');
  var store = [];
  codeBlocks.forEach(function (codeBlock) {
    store.push(codeBlock);
  });
  codeBlocks = el.querySelectorAll('code');
  codeBlocks.forEach(function (codeBlock, index) {
    store[index].innerHTML = store[index].innerHTML.replace(/(\r\n|\n|\r)/gm, '<br>');
    codeBlock.replaceWith(store[index]);
  });
  var spoilerContainers = el.querySelectorAll('.spoiler-container');
  var contentSpoilers = el.querySelectorAll('.content-spoiler');

  if (spoilerContainers.length) {
    spoilerContainers.forEach(function (spoilerContainer, i) {
      var spoilerEl = document.createElement('content-spoiler');
      spoilerEl.innerHTML = contentSpoilers[i].innerHTML;
      spoilerContainer.before(spoilerEl);
      spoilerContainer.remove();
    });
  }

  var figureCaptions = el.querySelectorAll('figcaption');
  figureCaptions.forEach(function (caption) {
    var _caption$textContent;

    if (!((_caption$textContent = caption.textContent) !== null && _caption$textContent !== void 0 ? _caption$textContent : '').trim()) {
      caption.remove();
    }
  });
  var quoteUsers = el.querySelectorAll('.content-quote-username');
  quoteUsers.forEach(function (quote) {
    quote.remove();
  });
  return el.innerHTML;
};

exports.fromEditorFormat = fromEditorFormat;